module.exports = __webpack_public_path__ + "SC.png?efb836f2e4d3326e7c1d33352bb62007";